import { BACKEND_URL } from "constants/envs"
import Keycloak from "keycloak-js";


const keycloak = new Keycloak(BACKEND_URL + '/rest/config/keycloak.json');

export default keycloak;
